import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import FormActionButton from 'libs/forms/views/formActionButton';
import { FormWrapper, FormField, Label } from 'libs/forms/styles';
import {
  SettingsSection,
  FullWidthDivider,
  Center,
} from 'legacyComponents/styled/lib';

import { SectionTitle } from 'apps/group/styles';

import { ChangePasswordAppManager } from 'apps/profile/settings/tabs/account/changePassword/appManager';

@withNamespaces()
@observer
export class ChangePassword extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new ChangePasswordAppManager(null, {});
  }

  render() {
    const {
      app: { form },
    } = this.appManager;

    const currentPasswordField = form.fieldStores.get('currentPassword');
    const newPasswordField = form.fieldStores.get('newPassword');

    return (
      <div className='w-full'>
        <SettingsSection>
          <SectionTitle level={2} size='medium'>
            <Trans>Change Password</Trans>
          </SectionTitle>
          <FullWidthDivider />
          <FormWrapper
            responsive
            posting={form.posting}
            onSubmit={e => {
              e.preventDefault();
              form.prepare();
              this.appManager.app.Submit();
            }}
          >
            <FormField>
              <Label>
                <Trans>Current Password</Trans>
              </Label>
              <PasswordField
                fieldStore={currentPasswordField}
                noValidation
                responsive
              />
            </FormField>
            <FormField>
              <Label>
                <Trans>New Password</Trans>
              </Label>
              <PasswordField
                fieldStore={newPasswordField}
                noValidation
                responsive
              />
            </FormField>
            <Center>
              <FormActionButton
                formStore={form}
                buttonText={form.conf.buttonText}
                buttonTextPosting={form.conf.buttonTextPosting}
                size='small'
                // FIXME: remove this inline style
                style={{ marginTop: '1rem' }}
                outline
              />
            </Center>
          </FormWrapper>
        </SettingsSection>
      </div>
    );
  }
}
